module.exports = __webpack_public_path__ + "static/img/meirenzheng.d27fdb93.png";